module.exports = __webpack_public_path__ + "dda99df645045d88b40f0681c40df849.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/OMDCLogo.svg
// module id = 228
// module chunks = 0